import React from 'react';
import { addDays, endOfISOWeek, format, startOfISOWeek, subDays } from "date-fns";
import { useEffect, useState } from "react";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";

type IProps = {
    canLoad: boolean
    from: string
    to: string
    setStartEndOfSelectedWeek: Function
}

const NextPrevWeekDates: React.FC<IProps> = ({from, to, canLoad, setStartEndOfSelectedWeek}) => {

    // const [currentStartOfDay, setCurrentStartOfDay] = useState(startOfDay(new Date()));
    const [startOfWeek, setStartOfWeek] = useState<Date>();
    const [endOfWeek, setEndOfWeek] = useState<Date>();

    useEffect(() => {
        if (from) {
            setStartOfWeek(new Date(from));
        } else {
            setStartOfWeek(startOfISOWeek(new Date()));
        }

        if (to) {
            setEndOfWeek(new Date(to));
        } else {
            setEndOfWeek(endOfISOWeek(new Date()));
        }
    }, [from, to]);

    const handleChange = (direction: string) => {
        let ref = new Date();
        switch (direction) {
            case 'forward': {
                ref = addDays(endOfWeek!, 1);
                break;
            }
            case 'backward': {
                ref = subDays(startOfWeek!, 1);
                break;
            }
        }
        const startDate = startOfISOWeek(ref);
        const endDate = endOfISOWeek(ref);
        setStartOfWeek(startDate);
        setEndOfWeek(endDate);
        setStartEndOfSelectedWeek({ from: format(startDate, "yyyy-MM-dd"), to: format(endDate, "yyyy-MM-dd") });
    }

    return (
        <div className='d-flex align-items-center justify-content-center next-preview-week-dates'>
            <div onClick={() => handleChange('backward')} className={`next-preview-btn preview-back-btn ${!canLoad ? 'disabled' : ''} cursor-pointer`}>
                <MdArrowBackIos />
            </div>
            <p className='fs-14 text-black fw-bold pd-x-15'>{startOfWeek && format(startOfWeek, "dd")} - {endOfWeek && format(endOfWeek, "dd MMM yyyy")}</p>
            <div onClick={() => handleChange('forward')} className={`next-preview-btn ${!canLoad ? 'disabled' : ''} cursor-pointer`}>
                <MdArrowForwardIos />
            </div>
        </div>
    )
}

export default NextPrevWeekDates;